import styled from "styled-components"

export const DivInput = styled.div`
    display: block;
    margin: 0 0 15px 0;
    label{
        display: block;
        width: 100%;
        font-size: 90%;
        color: var(--font);
    }
    input{
        width: 100%;
        background: transparent;
        border: none;
        padding: 15px 0;
        //border-bottom: 1px solid rgba(0,0,0,.1);
    }
`;

export const DivInputAlt = styled.div`
    position: relative;
    display: block;
    margin: 15px 0;
    label{
        display: block;
        width: 100%;
        font-size: 90%;
        color: var(--font);
    }
    .input-container {
        width: 100%;
        margin-top: 10px;
        background: #fff;
        color: var(--font);
        border-radius: 5px;
        overflow: hidden;
        border: none;
        display: flex;
        align-items: center;
        height: 50px;
        box-shadow: 0px 10px 10px rgba(0,0,0,.03);
        svg {
            margin: 0 0 0 10px;
            width: 15px;
        }
        input{
            width: 100%;
            height: 100%;
            padding: 8px 15px;
            border: none;
        }
    }
    .reset{
        display: flex;
        align-items: center;
        position: absolute;
        right: 3px;
        bottom: 17px;
        background: none;
        border: none;
        border-right: 6px solid #FFF;
        color: var(--danger);
        span{
            font-size: 90%;
        }
        svg{
            width: 16px;
            height: 16px;
            margin-left: 2px;
        }
    }
`;